import { queryOptions } from "@tanstack/react-query";

import { getGrowPractice } from "~/lib/functions/cih/grow-practice";

export function growPracticeQueryOptions(userId: string | undefined) {
  return queryOptions({
    queryKey: ["grow-practice", userId],
    queryFn: () => getGrowPractice(),
    // Her band moves only with a new score, and the pages only when an admin
    // publishes. The same minute as her score read (`myReadinessQueryOptions`)
    // also lets the client reuse the server render's read instead of repeating
    // it on mount.
    staleTime: 60 * 1000,
    enabled: !!userId,
  });
}
